import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'

const ServiziAggiuntivi = () => (
  <Paper style={styles.paper}>
    <h4 style={styles.titles}>Servizi Aggiuntivi</h4>
    <p>
      Causa aggiornamento del Sito i servizi aggiuntivi non sono momentaneamente disponibili. Ci scusiamo per il disagio, li riattiveremo il prima possibile.
    </p>
  </Paper>
)

export default ServiziAggiuntivi



// WEBPACK FOOTER //
// ./src/common/Infotext/ServiziAggiuntivi.js